module.exports = __webpack_public_path__ + "img/btn_vote_deco2.83308250.png";